(function () {
  const drawer = document.getElementById('DuoMobileMenu');
  if (!drawer) return;

  const panel = drawer.querySelector('.duo-menu__panel');
  const closeBtn = drawer.querySelector('[data-duo-close]');
  const mobile = window.matchMedia('(max-width: 749px)');
  let lastFocus = null;

  function openMenu() {
    if (!mobile.matches) return;

    lastFocus = document.activeElement;

    document.documentElement.classList.add('duo-menu-open');
    document.body.classList.add('duo-menu-open');

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');

    setTimeout(function () {
      if (panel) panel.focus();
    }, 0);
  }

  function closeMenu() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');

    document.documentElement.classList.remove('duo-menu-open');
    document.body.classList.remove('duo-menu-open');

    document.querySelectorAll('details[open]').forEach(function (details) {
      if (
        details.querySelector('.menu-drawer') ||
        details.querySelector('[id*="menu" i]') ||
        details.className.toString().toLowerCase().includes('menu')
      ) {
        details.removeAttribute('open');
      }
    });

    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener(
    'click',
    function (event) {
      const trigger = event.target.closest('[data-duo-mobile-open]');
      if (!trigger || !mobile.matches) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      openMenu();
    },
    true
  );

  if (closeBtn) {
    closeBtn.addEventListener('click', closeMenu);
  }

  drawer.addEventListener('click', function (event) {
    if (event.target === drawer) closeMenu();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeMenu();
    }
  });

  mobile.addEventListener('change', function () {
    if (!mobile.matches) closeMenu();
  });

  window.DuoMobileMenu = {
    open: openMenu,
    close: closeMenu
  };
})();